import { render, staticRenderFns } from "./huovAirbnbAlterationReq.vue?vue&type=template&id=23a737f4"
import script from "./huovAirbnbAlterationReq.vue?vue&type=script&lang=js"
export * from "./huovAirbnbAlterationReq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports